import React from 'react'

const Stepper = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="stepper-wrap" style={{
      background: 'var(--white)',
      borderBottom: '1px solid var(--border)',
      padding: '0 40px'
    }}>
      <div className="stepper" style={{
        display: 'flex',
        maxWidth: '880px',
        margin: '0 auto'
      }}>
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'done' : ''}`}
            onClick={() => onStepClick(index)}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              padding: '18px 0',
              position: 'relative',
              cursor: 'pointer'
            }}
          >
            {/* Connector line */}
            {index < steps.length - 1 && (
              <div style={{
                content: '',
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '1px',
                background: 'var(--border)',
                zIndex: 0,
                left: '50%',
                right: 'auto',
                width: '50%'
              }}></div>
            )}
            
            {/* Step circle */}
            <div
              className={`step-circle ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'done' : ''}`}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'var(--font-m)',
                fontSize: '12px',
                fontWeight: '500',
                border: '2px solid var(--border)',
                background: 'var(--white)',
                color: 'var(--text3)',
                zIndex: 1,
                flexShrink: 0,
                transition: 'all 0.3s',
                ...(index === currentStep && {
                  borderColor: 'var(--gold)',
                  background: 'var(--gold)',
                  color: 'var(--navy)',
                  fontWeight: '700'
                }),
                ...(index < currentStep && {
                  borderColor: 'var(--teal)',
                  background: 'var(--teal)',
                  color: 'var(--white)'
                })
              }}
            >
              {index < currentStep ? '✓' : index + 1}
            </div>
            
            {/* Step info */}
            <div className="step-info" style={{ marginLeft: '10px' }}>
              <div className="step-num" style={{
                fontSize: '10px',
                color: 'var(--text3)',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: '500'
              }}>
                Step {index + 1}
              </div>
              <div className={`step-name ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'done' : ''}`} style={{
                fontSize: '13px',
                color: 'var(--text2)',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                ...(index === currentStep && {
                  color: 'var(--navy)',
                  fontWeight: '600'
                }),
                ...(index < currentStep && {
                  color: 'var(--teal)'
                })
              }}>
                {step.name}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Stepper
